<template>
<div class="chapter">
<div class="inner_page">
<div class="photo"><img alt="Shield.png" class="img90" src="Images/Shield.png"/></div>
<p class="caption_fig"><b>Figure 1.</b> Bishop Lightfoot's Bookplate</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bookplate.vue?192a2d4c